<script lang="ts" setup>
import { Slot } from 'radix-vue'
import { useFormField } from './useFormField'
import { inject } from 'vue'

const { error, formItemId, formDescriptionId, formMessageId, value } = useFormField()

const props = defineProps<{
  forceDisplayState?: 'display' | 'input'
}>()

const onlyDisplay =
  props.forceDisplayState !== undefined
    ? props.forceDisplayState !== 'input'
    : inject('pejer-form-display-only', false)
</script>

<template>
  <Slot
    :id="formItemId"
    :aria-describedby="!error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`"
    :aria-invalid="!!error"
  >
    <slot v-if="!onlyDisplay" />
    <slot v-else-if="$slots.display" name="display" />
    <h4 class="font-bold bg-slate-50 p-3 rounded-sm" v-else>
      <span v-if="value">{{ value }}</span>
      <span v-else class="italic text-gray-400"> Ingen verdi satt </span>
    </h4>
  </Slot>
</template>
